export const getGeocodeByPlaceId = async (
  placeId: string,
): Promise<google.maps.GeocoderResult[]> => {
  const geocoder = new google.maps.Geocoder();
  return new Promise((resolve, reject) => {
    geocoder.geocode({ placeId }, (results, status) => {
      if (status === 'OK' && results) {
        resolve(results);
      } else {
        reject(new Error(`Geocoding failed: ${status}`));
      }
    });
  });
};

export const getGeocodeByAddress = async (
  address: string,
): Promise<google.maps.GeocoderResult[]> => {
  const geocoder = new google.maps.Geocoder();
  return new Promise((resolve, reject) => {
    geocoder.geocode({ address }, (results, status) => {
      if (status === 'OK' && results) {
        resolve(results);
      } else {
        reject(new Error(`Geocoding failed: ${status}`));
      }
    });
  });
};

export const getLatLng = (
  result: google.maps.GeocoderResult,
): { lat: number; lng: number } => {
  const location = result.geometry.location;
  return {
    lat: location.lat(),
    lng: location.lng(),
  };
};

interface IGetAddressProps {
  street_address_one: string;
  street_address_two: string;
  suburb_city: string;
  province: string;
  postal_code: string;
  country: string;
}

export const getAddress = ({
  street_address_one,
  street_address_two,
  suburb_city,
  province,
  postal_code,
  country = 'Australia',
}: Partial<IGetAddressProps>) =>
  [
    street_address_one,
    street_address_two,
    suburb_city,
    province,
    postal_code,
    country,
  ]
    .filter(Boolean)
    .join(', ');

export const getCurrentPosition = (): Promise<GeolocationPosition> =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser'));
      return;
    }

    const options = {
      enableHighAccuracy: false, // Changed to false to reduce rate limiting
      timeout: 15000, // Reduced timeout to 15 seconds
      maximumAge: 300000, // Increased cache to 5 minutes
    };

    const successHandler = (position: GeolocationPosition) => {
      resolve(position);
    };

    const errorHandler = (error: GeolocationPositionError) => {
      let errorMessage: string;

      switch (error.code) {
        case error.PERMISSION_DENIED:
          errorMessage =
            'Location permission denied. Please enable location access.';
          break;
        case error.POSITION_UNAVAILABLE:
          errorMessage =
            'Location service temporarily unavailable. Please try again later.';
          break;
        case error.TIMEOUT:
          errorMessage = 'Location request timed out. Please try again.';
          break;
        default:
          errorMessage = `Location error: ${error.message}`;
      }

      reject(new Error(errorMessage));
    };

    navigator.geolocation.getCurrentPosition(
      successHandler,
      errorHandler,
      options,
    );
  });
